import React, { Component } from "react";
import Paper from '@material-ui/core/Paper';
import Snackbar from "@material-ui/core/Snackbar";
import { MyContext } from "../../MyProvider";
import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
import { theme } from '../../themController';
import ChangePassword from "./ChangePassword";

import {
  getNarratives
} from '../general_functions/narrativeFunctions';


export default class Settings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      snackbarText: "",
      openSnackbar: false,
    };
  }

  handleChange = (event, value) => {
    this.setState({ value });
  };

  handleSnackbar = (text) => {
    this.setState({
      openSnackbar: true,
      snackbarText: text
    });
  };

  render() {
    return (
      <MyContext.Consumer>
        {context => {
          return (
            <MuiThemeProvider theme={theme}>
              <Paper>
                <ChangePassword
                  context={context}
                  handleSnackbar={this.handleSnackbar}
                />
              </Paper>

              <Snackbar
                open={this.state.openSnackbar}
                message={this.state.snackbarText}
                autoHideDuration={4000}
                onRequestClose={() => this.setState({ openSnackbar: false })}
              />
            </MuiThemeProvider>
          );
        }}
      </MyContext.Consumer>
    );
  }
}
